export default __webpack_public_path__ + "locales/nl/SharingPanel.json?hash=8622d99e9e2d8e713ef70b1ee11f8cdf";